import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isDate } from '../utils';

export const minDate = (minDate: any): ValidatorFn => {
  const key = 'minDate';

  if (!isDate(minDate) && !(minDate instanceof Function)) {
    throw Error('minDate value must be or return a formatted date');
  }

  return (control: AbstractControl): ValidationErrors | null => {
    const value: any = control.value;
    if (!value) return null;

    const date: Date = new Date(value);
    if (!isDate(date)) return { [key]: true };
    if (minDate instanceof Function) minDate = minDate();
    if (date < new Date(minDate)) return { [key]: true };

    return null;
  };
};
